'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
var React = require('react');
var React__default = _interopDefault(React);
var styled = require('styled-components');
var styled__default = _interopDefault(styled);

var Container = styled__default.div(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n  height: 1rem;\n  background: ", ";\n"], ["\n  height: 1rem;\n  background: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.greys.sharedGreyBackground;
});
var Bar = styled__default.div(templateObject_2 || (templateObject_2 = tslib_es6.__makeTemplateObject(["\n  height: 100%;\n  background: ", ";\n  width: ", ";\n  transition: width .3s;\n"], ["\n  height: 100%;\n  background: ", ";\n  width: ", ";\n  transition: width .3s;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.admin.greenAlt2;
}, function (_a) {
    var width = _a.width;
    return width + "%";
});
var ProgressBar = function (_a) {
    var width = _a.width, _b = _a.className, className = _b === void 0 ? '' : _b;
    return (React__default.createElement(Container, { className: className, "data-testid": "progress-container" },
        React__default.createElement(Bar, { width: width, className: "progress-bar", "data-testid": "progress-bar" })));
};
var templateObject_1, templateObject_2;

exports.ProgressBar = ProgressBar;
